module.exports = __webpack_public_path__ + "assets/img/NU.da8fd5b3.svg";